<template>
  <Teleport to="body">
    <div class="howto-backdrop" @click.self="close">
      <div class="howto" role="dialog" aria-label="How to play">
        <button class="howto__close" aria-label="Close" @click="close">✕</button>

        <div class="howto__body">
          <h3>{{ slide.title }}</h3>

          <img
            v-if="slide.card"
            class="howto__card"
            :src="`/cards/${slide.card}.jpg`"
            :alt="slide.cardAlt"
          />

          <!-- eslint-disable-next-line vue/no-v-html -- content is this file's own
               constant strings below, never user input -->
          <p v-for="(line, i) in slide.lines" :key="i" class="howto__line" v-html="line" />
        </div>

        <div class="howto__nav">
          <button class="secondary" :disabled="index === 0" @click="index -= 1">Back</button>
          <span class="howto__dots">
            <i
              v-for="(s, i) in slides"
              :key="i"
              class="howto__dot"
              :class="{ 'howto__dot--on': i === index }"
            />
          </span>
          <button v-if="index < slides.length - 1" class="primary howto__next" @click="index += 1">
            Next
          </button>
          <button v-else class="primary howto__next" @click="close">
            Got it
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script>
// The walkthrough - the house pattern (auto-opens once, behind ? after).
// The illustrations are the real cards. The claims here are asserted against
// the engine in howToPlay.test.js so the tutorial cannot drift from the
// rules it teaches.
const SLIDES = [
  {
    title: 'Chart the wilderness',
    card: 110,
    cardAlt: 'The Great River explore card',
    lines: [
      'Each turn flips one card, and <strong>everyone draws it on their own map at the same time</strong> — pick one of the card\'s shapes, rotate or flip it however you like, and place it anywhere it fits.',
      'Some cards offer a choice of terrain; some offer a smaller shape that pays a <strong>coin</strong>. Surrounding a mountain on all four sides also pays a coin.',
      'If nothing fits, you draw a single square anywhere instead.',
    ],
  },
  {
    title: 'The queen’s edicts',
    card: 400,
    cardAlt: 'The Spring season card',
    lines: [
      'Four scoring cards sit under the edicts <strong>A, B, C and D</strong> — a fresh draw every game.',
      'The year runs <strong>Spring, Summer, Fall, Winter</strong>, and each season scores two of them: A+B, then B+C, then C+D, then D+A. Every edict counts twice, so nothing you build stops mattering.',
      'Each card\'s hourglass fills the season\'s time; when it\'s full, the season is scored — edicts, plus a star per coin, <strong>every season</strong>.',
    ],
  },
  {
    title: 'Ruins and ambushes',
    card: 100,
    cardAlt: 'The Goblin Attack ambush card',
    lines: [
      'A <strong>ruins</strong> card binds the next shape: it must cover one of the six ruins spaces on your map.',
      'An <strong>ambush</strong> passes every map to a neighbour, who draws the monster shape on it — wherever it hurts most.',
      'At every season\'s scoring you lose a star for <strong>each empty space touching a monster</strong>. Wall them in and they stop costing you.',
    ],
  },
  {
    title: 'Winning the year',
    card: 403,
    cardAlt: 'The Winter season card',
    lines: [
      'After Winter\'s scoring, the four season totals add up; the most reputation stars is the greatest cartographer in the kingdom.',
      'Nobody waits on anybody — the table moves as fast as its slowest sketcher. <strong>Robots</strong> can fill seats, chart their own maps, and draw monsters on yours.',
      'Your map is yours alone to fill. The only thing anyone else touches is where the monsters go.',
    ],
  },
];

export default {
  name: 'HowToPlay',
  emits: ['close'],
  data() {
    return { index: 0, slides: SLIDES };
  },
  computed: {
    slide() { return this.slides[this.index]; },
  },
  methods: {
    close() { this.$emit('close'); },
  },
};
</script>
